import { useMediaQuery } from "@material-ui/core";
import React from "react";
import { createUseStyles } from "react-jss";
import { useParams } from "react-router-dom";
import NoCustomership from "./components/NoCustomership";
import TechError from "./components/TechError";

export enum ErrorType {
  NoCustomership = "nocustomership",
  TechError = "techerror",
}

interface Params {
  errorType: ErrorType;
}

const useStyles = createUseStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const Error = () => {
  const classes = useStyles();

  const matchesMediaQuery = useMediaQuery("(min-width: 600px)");

  const { errorType } = useParams<Params>();

  const getCorrectError = (type: ErrorType) => {
    switch (type) {
      case ErrorType.NoCustomership:
        return <NoCustomership />;
      case ErrorType.TechError:
        return <TechError />;
      default:
        return <></>;
    }
  };

  return (
    <div
      className={classes.container}
      style={{
        height: matchesMediaQuery ? "calc(100% - 270px)" : "calc(100% - 230px)",
      }}
    >
      {getCorrectError(errorType)}
    </div>
  );
};

export default React.memo(Error);
